import { Injectable } from '@angular/core';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(public api: ApiService)
  {

  }

  sendContactFormEmail($params: object)
  {

    this.api.setEndpoint('contactformmailing/sendcontactformemail');

    return this.api.POST($params);
  }



}
